import {
  set as setOnClient,
  setWithExpiry as setWithExpiryOnClient,
  getWithExpiry as getWithExpiryOnClient,
} from './client-cache';
import {
  setWithExpiry as setWithExpiryOnServer,
  getWithExpiry as getWithExpiryOnServer,
} from './server-cache';
/**
 * This function syncs server and client cache. Sets data in client cache if its already not cached
 * @param serverData cached data of server
 */
export const syncCache = serverData => {
  for (const [key, value] of serverData) {
    if (!getWithExpiryOnClient(key)) {
      setOnClient(key, value);
    }
  }
};
/**
 * This functions sets data in cache depending upon its server side rendering(SSR) or client side rendering(CSR)
 * @param key key user for setting data
 * @param jsonValue JSON object of the value
 * @param ttlInMs  TTL in milli seconds
 */
export const setDataInCache = (key, jsonValue, ttlInMs) => {
  if (ssr.isOnClient) {
    setWithExpiryOnClient(key, jsonValue, ttlInMs);
  } else {
    setWithExpiryOnServer(key, jsonValue, ttlInMs);
  }
};
/**
 * Returns cached JSON object if its not expired otherwise null
 * @param key key for data retrival
 */
export const getDataFromCache = key => {
  if (ssr.isOnClient) {
    return getWithExpiryOnClient(key);
  }
  return getWithExpiryOnServer(key);
};

const ONE_SECOND = 1000;
const ONE_MINUT = 60 * ONE_SECOND;
const ONE_HOUR = 60 * ONE_MINUT;

export const CACHE_TTL_MS = {
  COVID_DATA: 24 * ONE_HOUR, // 24 hours,
  FUNNEL: 5 * ONE_MINUT, // 5 mins
  FUNNEL_KEY: 5 * ONE_MINUT, // 5 mins
};
